<template>
  <section class="vbox"> 
   <section class="hbox stretch">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>卡务中心</span>
        </div>
        <div >
          <el-form @submit.native.prevent :inline="true"  size="medium"  >     
            <el-form-item >
              <el-input  ref="number" v-model="number" placeholder="请输入会员号/手机号"></el-input>
            </el-form-item>        
            <el-form-item>
              <el-button type="primary" v-on:click="Search">查询</el-button>
              <el-button type="default"  v-on:click="ExchangeCard">绑卡</el-button>
              <el-button type="default">修改密码</el-button>
              <el-button type="default">店铺</el-button>
              <el-button type="default">推荐人</el-button>
              <!-- <el-button type="default"   >赠送代金券</el-button> -->
            </el-form-item>
          </el-form>
          <el-tabs v-model="activeName" type="card" >
            <el-tab-pane label="会员信息" name="0">       
              <el-form ref="form" v-model="member" label-width="90px" size="medium" >
                <el-col :span="8">
                  <el-form-item label="会员号">
                    <el-input v-model="member.number"  :readonly="true"></el-input>
                  </el-form-item>    
                </el-col>   
                <el-col :span="8">
                  <el-form-item label="会员名称">
                    <el-input v-model="member.name"  ></el-input>
                  </el-form-item>    
                </el-col>  
                <el-col :span="8">
                  <el-form-item label="实体卡号">
                    <el-input v-model="member.uId"  :readonly="true" ></el-input>
                  </el-form-item>    
                </el-col> 
                <el-col :span="8">
                  <el-form-item label="联系电话">
                    <el-input v-model="member.mobile" size="medium"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="积分">
                    <el-input v-model="member.availablePoint"  :readonly="true" >
                      <template slot="append">分</template>
                    </el-input>
                  </el-form-item>    
                </el-col> 
                <el-col :span="8">
                  <el-form-item label="奖励金">
                    <el-input v-model="member.availableReward" :readonly="true"  >
                      <template slot="append">元</template>
                    </el-input>
                  </el-form-item>    
                </el-col> 
                <el-col :span="8">
                  <el-form-item label="性别">
                    <el-radio-group v-model="member.gender">
                      <el-radio :label="1">男</el-radio>
                      <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="生日">
                    <el-date-picker
                      v-model="member.birthday"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>   
                </el-col>     
                <el-col :span="24" >      
                  <el-form-item label-width="200px">
                    <el-button type="primary" @click="SaveMember">保  存</el-button>
                  </el-form-item>
                </el-col> 
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="订单记录" name="1">
              <OrderNote :memberId="memberId"></OrderNote>
            </el-tab-pane>
            <el-tab-pane label="消费记录" name="2">
              <ConsumeNote :memberId="memberId"></ConsumeNote>
            </el-tab-pane>
            <el-tab-pane label="余额卡" name="3">              
              <CardNote :memberId="memberId"></CardNote>
            </el-tab-pane>
            <!-- <el-tab-pane label="代金券" name="4">定时任务补偿</el-tab-pane> -->
            <el-tab-pane label="余额记录" name="5" >    
              <ValueNote :memberId="memberId"></ValueNote>
            </el-tab-pane>
            <el-tab-pane label="奖励金记录" name="6">              
              <RewardNote :memberId="memberId"></RewardNote>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-card> 

   </section>
   <diaExchangeCard v-bind:dialog="dialogExchangeCard"></diaExchangeCard>
  </section>
</template>

<script  type='text/ecmascript-6'>
  import OrderNote from './orderNote'
  import CardNote from './cardNote'
  import ValueNote from './valueNote'
  import ConsumeNote from './consumeNote'
  import RewardNote from './rewardNote'
  import diaExchangeCard from './exchangeCard'
  export default {
    data (){
      return {
        number:'',
        activeName:'0',
        member:{},
        memberId:0,
        dialogExchangeCard:{
          isShow:false,
          id:0
        }
      }
    },
    components:{
      OrderNote,
      CardNote,
      ValueNote,
      ConsumeNote,
      RewardNote,
      diaExchangeCard
    },
    computed:{
    },
    mounted(){
    },
    methods:{  
      Search:function(){
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Member/GetByNo',
          params:{
            no:that.number
          }
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.member = resp.data.member
            that.memberId = resp.data.member.id
          }else{            
            that.$message.warning(resp.data.message);
          }
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      SaveMember:function(){
        var that = this
        if(this.memberId == 0){
          that.$message.warning('请先读取会员卡');
          return
        }
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/Member/Edit',
          data: that.member      
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else{            
            that.$message.warning(resp.data.message);
          }
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      ExchangeCard(){
        var that = this
        if(this.memberId == 0){
          that.$message.warning('请先读取会员卡');
          return
        }
        this.dialogExchangeCard.id = this.memberId
        this.dialogExchangeCard.isShow = true
      }

    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.box-card
  margin 20px
.left0
  margin-left 0px

</style>